<div class="substitution-fields">
	<label>Substitution Fields</label>
	<p>Click to copy to clipboard, and then paste into template.</p>
	<ul>
		<li *ngFor="let field of substitutionFields" (click)="copyToClipboard(field)">
			<span>{{ field }}</span>
			<span class="material-symbols-outlined">content_copy</span>
		</li>
		<li *ngIf="showVimeoOption" (click)="showCopyVimeoUrlDialog()">
			<span>{{'{{Vimeo URL}}'}}</span>
			<span class="material-symbols-outlined">content_copy</span>
		</li>
	</ul>
</div>

<p-dialog [(visible)]="vimeoUrlVisible" [header]="'Copy Vimeo Url'" [style]="{ width: '35%' }">
	<p>Enter the ID of the Vimeo video</p>
	<div class="vimeo-form">
		<div class="field">
			<label>Vimeo video ID</label>
			<input pInputText [(ngModel)]="vimeoVideoId" />
		</div>
	</div>
	<footer class="vimeo-footer">
		<div class="button success" (click)="copyVimeoUrl()">Copy to Clipboard</div>
		<div class="button neutral" (click)="vimeoUrlVisible = false">Cancel</div>
	</footer>
</p-dialog>
